const items = Object.freeze({
  CSEE: { id: 1, name: "Oficina Central" },
  CENTER: { id: 2, name: "Nivel Centro" },
  SCHOOL: { id: 3, name: "Nivel Escuela" }
});
export default items;
